<template>
  <IndexPresentation :shop-list="shopList" :notice-list="noticeList"/>
</template>

<script>
import { requestIndexData } from '@/assets/request'
import IndexPresentation from '@/components/top/IndexPresentation.vue'
import { postAccessLog } from '@/assets/request/api/postAccessLog'
import { getNoticeCsv } from '@/assets/request/csv/getNoticeCsv'

const RequestPortalIdMap = {
  shops: 'shop',
  schools: 'school',
  hospitals: 'hospital',
}

export default {
  name: 'Index',
  components: {
    IndexPresentation,
  },
  data() {
    return {
      shopList: [],
      noticeList: [],
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (
      to.query.status === 'signout' ||
      to.params.portalId !== from.params.portalId
    ) {
      const response = await requestIndexData(
        RequestPortalIdMap[to.params.portalId]
      )

      this.setData(response)

      next()

      if (to.query.status === 'signout') {
        this.$router.replace({
          name: 'Index',
          params: { portalId: to.params.portalId },
        })
        this.$toasted.show(this.$t('ログアウトしました'))
      }
      return
    }

    next()
  },
  async beforeRouteEnter(to, _from, next) {
    const response = await requestIndexData(
      RequestPortalIdMap[to.params.portalId]
    )
    const result = await getNoticeCsv()
    if (result.isError) {
      // console.log('not found notice file.')
    }

    next((mv) => {
      mv.setData(response)
      if (!result.isError) {
        mv.setNoticeList(result.data.list)
      } else {
        mv.setNoticeList([])
      }

      if (to.query.status === 'signout') {
        mv.$router.replace({
          name: 'Index',
          params: { portalId: mv.portalId },
        })
        mv.$toasted.show(mv.$t('ログアウトしました'))
      }
    })
  },
  methods: {
    setData(shopList) {
      if (!shopList.isError) {
        this.shopList = shopList.data.list
      }
    },
    setNoticeList(list) {
      this.noticeList = list
    },
  },
  mounted(){
    postAccessLog('Top', 'top_' + this.$route.params.portalId, location.href)
  },
}
</script>
